import {ProductVariantOption} from '@/product/types';
import {ProductOptionSettingsMap} from '@/settings/types';

/**
 * Get option settings for a given option
 */
export function getOptionSettings(
  option: ProductVariantOption,
  optionName: string,
  optionSettingsMap: ProductOptionSettingsMap
) {
  return optionSettingsMap.find(
    ({name, value}) => name === optionName && value === option.optionValue
  );
}

/**
 * Format color name to be used as a class name
 */
export function formatColorName(color: string) {
  return color.trim().replace(/\s/g, '-').toLowerCase();
}
